const DialmakerDesktopColors = {
  link: '#0072E5',
};

export default DialmakerDesktopColors;
